import * as React from "react";

const SvgMusicRights = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 25 24"
  >
    <mask
      id="music_rights_svg__a"
      width={25}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="currentColor" d="M.412 0h24v24h-24z" />
    </mask>
    <g mask="url(#music_rights_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.512 21.213a9.7 9.7 0 0 0 3.9.787 9.7 9.7 0 0 0 3.9-.788 10.1 10.1 0 0 0 3.175-2.137q1.35-1.35 2.137-3.175a9.7 9.7 0 0 0 .788-3.9 9.7 9.7 0 0 0-.788-3.9 10.1 10.1 0 0 0-2.137-3.175q-1.35-1.35-3.175-2.137a9.7 9.7 0 0 0-3.9-.788 9.7 9.7 0 0 0-3.9.788 10.1 10.1 0 0 0-3.175 2.137Q3.987 6.275 3.199 8.1a9.7 9.7 0 0 0-.787 3.9q0 2.075.787 3.9a10.1 10.1 0 0 0 2.138 3.175q1.35 1.35 3.175 2.137m9.575-3.538Q15.762 20 12.412 20t-5.675-2.325T4.412 12t2.325-5.675Q9.06 4 12.412 4t5.675 2.325T20.412 12t-2.325 5.675m-4.44.037a5.84 5.84 0 0 0 2.99-1.674l-1.376-1.315a3.941 3.941 0 1 1 .006-5.439l1.38-1.311a5.844 5.844 0 1 0-3 9.739"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default SvgMusicRights;
